// AREC - Modern Fashion Theme JS
(function() {
  'use strict';

  // Utility
  const $ = s => document.querySelector(s);
  const $$ = s => [...document.querySelectorAll(s)];

  // Mobile Menu
  const mobileToggle = $('.mobile-menu-toggle');
  const mobileNav = $('.mobile-nav');
  const mobileOverlay = $('.mobile-nav-overlay');
  const mobileClose = $('.mobile-nav-close');

  mobileToggle?.addEventListener('click', () => {
    mobileNav?.classList.add('active');
    mobileOverlay?.classList.add('active');
    document.body.style.overflow = 'hidden';
  });

  [mobileClose, mobileOverlay].forEach(el => {
    el?.addEventListener('click', () => {
      mobileNav?.classList.remove('active');
      mobileOverlay?.classList.remove('active');
      document.body.style.overflow = '';
    });
  });

  // Enhanced Multi-Filter System for Collections
  const filterToggle = $('.filter-toggle');
  const filtersSidebar = $('.filters-sidebar');
  
  if (filterToggle && filtersSidebar) {
    filterToggle.addEventListener('click', () => {
      filtersSidebar.classList.toggle('active');
      if (filtersSidebar.classList.contains('active')) {
        filtersSidebar.style.display = 'block';
      } else {
        filtersSidebar.style.display = 'none';
      }
    });
  }

  // Clear All Filters button (JS-based clear for client-side filters)
  const clearAllBtn = $('.clear-all-filters-btn');
  if (clearAllBtn) {
    clearAllBtn.addEventListener('click', (e) => {
      e.preventDefault();
      // Reset all active filters
      activeFilters.size = [];
      activeFilters.color = [];
      activeFilters.category = [];
      activeFilters.price = { min: null, max: null };

      // Remove active classes from all filter UI elements
      $$('.size-option.active').forEach(el => el.classList.remove('active'));
      $$('.color-swatch.active').forEach(el => {
        el.classList.remove('active');
        el.style.boxShadow = '';
      });
      $$('.category-option.active').forEach(el => el.classList.remove('active'));

      // Clear price inputs
      $$('.price-inputs input').forEach(input => { input.value = ''; });

      // Navigate to clean collection URL
      window.location.href = window.location.pathname;
    });
  }

  // Multi-select filters with URL parameter handling
  const activeFilters = {
    size: [],
    color: [],
    category: [],
    price: { min: null, max: null }
  };

  // Parse current URL filters
  function parseURLFilters() {
    const params = new URLSearchParams(window.location.search);
    
    params.forEach((value, key) => {
      if (key.includes('filter.v.option.size')) {
        activeFilters.size.push(value.toLowerCase());
      } else if (key.includes('filter.v.option.color')) {
        activeFilters.color.push(value.toLowerCase());
      } else if (key.includes('filter.p.product_type')) {
        activeFilters.category.push(value.toLowerCase());
      } else if (key.includes('filter.v.price.gte')) {
        activeFilters.price.min = value;
      } else if (key.includes('filter.v.price.lte')) {
        activeFilters.price.max = value;
      }
    });
  }

  parseURLFilters();

  // Client-side product filtering
  function filterProducts() {
    const products = $$('.product-card');
    let visibleCount = 0;
    
    products.forEach(card => {
      const cardColors = (card.dataset.colors || '').toLowerCase();
      const cardSizes = (card.dataset.sizes || '').toLowerCase();
      const cardType = (card.dataset.type || '').toLowerCase();
      
      let showProduct = true;
      
      if (activeFilters.color.length > 0) {
        const hasMatchingColor = activeFilters.color.some(color => cardColors.includes(color.toLowerCase()));
        if (!hasMatchingColor) showProduct = false;
      }
      
      if (activeFilters.size.length > 0) {
        const hasMatchingSize = activeFilters.size.some(size => cardSizes.includes(size.toLowerCase()));
        if (!hasMatchingSize) showProduct = false;
      }
      
      if (activeFilters.category.length > 0) {
        const hasMatchingCategory = activeFilters.category.some(cat => cardType.includes(cat.toLowerCase()));
        if (!hasMatchingCategory) showProduct = false;
      }
      
      card.style.display = showProduct ? '' : 'none';
      if (showProduct) visibleCount++;
    });
    
    const grid = $('.product-grid');
    let emptyMsg = grid?.querySelector('.no-products-message');
    if (visibleCount === 0 && grid) {
      if (!emptyMsg) {
        emptyMsg = document.createElement('div');
        emptyMsg.className = 'no-products-message';
        emptyMsg.style.cssText = 'grid-column: 1/-1; text-align: center; padding: 60px 20px;';
        emptyMsg.innerHTML = '<h3>No products found</h3><p style="color:#666;margin:15px 0">Try adjusting your filters</p><button class="btn btn-primary clear-filters-btn">Clear Filters</button>';
        grid.appendChild(emptyMsg);
        emptyMsg.querySelector('.clear-filters-btn')?.addEventListener('click', () => {
          window.location.href = window.location.pathname;
        });
      }
      emptyMsg.style.display = '';
    } else if (emptyMsg) {
      emptyMsg.style.display = 'none';
    }
  }

  function applyFilters() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams();
    
    if (url.searchParams.get('sort_by')) {
      params.set('sort_by', url.searchParams.get('sort_by'));
    }
    
    activeFilters.size.forEach(size => {
      params.append('filter.v.option.size', size);
    });
    
    activeFilters.color.forEach(color => {
      params.append('filter.v.option.color', color);
    });
    
    activeFilters.category.forEach(category => {
      params.append('filter.p.product_type', category);
    });
    
    if (activeFilters.price.min) {
      params.set('filter.v.price.gte', activeFilters.price.min);
    }
    if (activeFilters.price.max) {
      params.set('filter.v.price.lte', activeFilters.price.max);
    }
    
    const newUrl = params.toString() ? `${url.pathname}?${params.toString()}` : url.pathname;
    window.history.replaceState({}, '', newUrl);
    
    filterProducts();
  }

  // Handle size filter clicks
  $$('.size-option').forEach(btn => {
    const size = btn.textContent.trim().toLowerCase();
    
    if (activeFilters.size.includes(size)) {
      btn.classList.add('active');
    }
    
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      
      if (activeFilters.size.includes(size)) {
        activeFilters.size = activeFilters.size.filter(s => s !== size);
        btn.classList.remove('active');
      } else {
        activeFilters.size.push(size);
        btn.classList.add('active');
      }
      
      applyFilters();
    });
  });

  // Handle color filter clicks
  $$('.color-swatch').forEach(btn => {
    const color = (btn.getAttribute('data-color') || btn.getAttribute('title') || '').toLowerCase();
    
    if (activeFilters.color.includes(color)) {
      btn.classList.add('active');
      btn.style.boxShadow = '0 0 0 2px #000';
    }
    
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      
      if (activeFilters.color.includes(color)) {
        activeFilters.color = activeFilters.color.filter(c => c !== color);
        btn.classList.remove('active');
        btn.style.boxShadow = '';
      } else {
        activeFilters.color.push(color);
        btn.classList.add('active');
        btn.style.boxShadow = '0 0 0 2px #000';
      }
      
      applyFilters();
    });
  });

  // Handle category filter clicks
  $$('.category-option').forEach(btn => {
    const category = (btn.getAttribute('data-category') || btn.textContent.trim() || '').toLowerCase();
    
    if (activeFilters.category.includes(category)) {
      btn.classList.add('active');
    }
    
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      
      if (activeFilters.category.includes(category)) {
        activeFilters.category = activeFilters.category.filter(c => c !== category);
        btn.classList.remove('active');
      } else {
        activeFilters.category.push(category);
        btn.classList.add('active');
      }
      
      applyFilters();
    });
  });

  if (activeFilters.color.length > 0 || activeFilters.size.length > 0 || activeFilters.category.length > 0) {
    filterProducts();
  }

  // Search Suggestions
  const searchInput = $('.search-form input[type="search"]');
  const searchSuggestions = $('.search-suggestions');

  searchInput?.addEventListener('input', async (e) => {
    const query = e.target.value.trim();
    if (query.length < 2) {
      searchSuggestions?.classList.remove('active');
      return;
    }

    try {
      const res = await fetch(`/search/suggest.json?q=${query}&resources[type]=product&resources[limit]=5`);
      const data = await res.json();
      const products = data.resources?.results?.products || [];
      
      if (products.length) {
        searchSuggestions.innerHTML = products.map(p => {
          let imgUrl = p.featured_image?.url || '';
          if (imgUrl) {
            imgUrl = imgUrl.replace(/(\.[^.]+)$/, '_100x100$1');
          }
          return `
            <a href="${p.url}" class="search-suggestion-item">
              <img src="${imgUrl}" alt="${p.title}" class="search-suggestion-image">
              <div class="search-suggestion-info">
                <div class="search-suggestion-title">${p.title}</div>
                <div class="search-suggestion-price">${p.price}</div>
              </div>
            </a>
          `;
        }).join('');
        searchSuggestions?.classList.add('active');
      }
    } catch (e) {}
  });

  // Cart Drawer
  const cartDrawer = $('.cart-drawer');
  const cartOverlay = $('.cart-drawer-overlay');
  const cartClose = $('.cart-drawer-close');

  $$('[data-cart-toggle], .cart-link').forEach(link => {
    link.addEventListener('click', async (e) => {
      e.preventDefault();
      await updateCartDrawer();
      cartDrawer?.classList.add('active');
      cartOverlay?.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  [cartClose, cartOverlay].forEach(el => {
    el?.addEventListener('click', () => {
      cartDrawer?.classList.remove('active');
      cartOverlay?.classList.remove('active');
      document.body.style.overflow = '';
    });
  });

  $$('.checkout-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = '/checkout';
    });
  });

  async function updateCartDrawer() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      
      const itemsEl = $('.cart-drawer-items');
      const totalEl = $('.cart-drawer-total span:last-child');
      
      if (cart.items.length === 0) {
        itemsEl.innerHTML = '<p style="text-align:center;padding:40px;color:#999">Your bag is empty</p>';
      } else {
        itemsEl.innerHTML = cart.items.map(item => `
          <div style="display:flex;gap:15px;padding:15px 0;border-bottom:1px solid #f0f0f0">
            <img src="${item.image}" style="width:80px;height:100px;object-fit:cover;background:#f8f8f8">
            <div style="flex:1">
              <div style="font-size:13px;font-weight:500;margin-bottom:5px">${item.product_title}</div>
              <div style="font-size:11px;color:#999;margin-bottom:8px">${item.variant_title}</div>
              <div style="font-weight:700">$${(item.final_line_price/100).toFixed(2)}</div>
              <div style="font-size:11px;color:#666;margin-top:5px">Qty: ${item.quantity}</div>
            </div>
          </div>
        `).join('');
      }
      
      if (totalEl) totalEl.textContent = `$${(cart.total_price/100).toFixed(2)}`;
      
      $$('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });

      // Update drawer count
      const drawerCount = $('.cart-drawer-count');
      if (drawerCount) drawerCount.textContent = cart.item_count;
    } catch (e) {}
  }

  // ============================================================
  // PRODUCT PAGE - Thumbnails, Tabs, Variants, Add to Cart
  // ============================================================
  const productJson = $('[data-product-json]');
  if (productJson) {
    const product = JSON.parse(productJson.textContent);

    // --- THUMBNAIL GALLERY ---
    $$('.pdp-thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        const mainImg = $('#main-product-image');
        if (mainImg && thumb.dataset.imageUrl) {
          mainImg.src = thumb.dataset.imageUrl;
        }
        $$('.pdp-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });

    // ============================================================
    // SHEIN-STYLE VARIANT SELECTOR LOGIC
    // ============================================================

    // Helper: get all currently selected option values in order
    function getSelectedOptions() {
      const options = [];
      product.options.forEach((optName, index) => {
        // Look for active button in this option group
        const group = document.querySelector(`.vs-option-group[data-option-index="${index}"]`);
        if (group) {
          const activeBtn = group.querySelector('.vs-swatch-btn.active, .vs-dot.active, .vs-size-pill.active');
          if (activeBtn) {
            options.push(activeBtn.dataset.optionValue);
          } else {
            // Fallback: use first value
            options.push(product.options_with_values ? product.variants[0].options[index] : '');
          }
        }
      });
      return options;
    }

    // Helper: find variant from selected options
    function findVariant(selectedOptions) {
      return product.variants.find(v =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );
    }

    // Helper: update the selected value label text
    function updateSelectedLabel(optionIndex, value) {
      const group = document.querySelector(`.vs-option-group[data-option-index="${optionIndex}"]`);
      if (group) {
        const label = group.querySelector('.vs-selected-value');
        if (label) label.textContent = value;
      }
    }

    // Helper: check which sizes are available for the current color selection (cross-option availability)
    function updateSizeAvailability() {
      const selectedOptions = getSelectedOptions();

      product.options.forEach((optName, index) => {
        const optLower = optName.toLowerCase();
        if (optLower === 'size' || optLower === 'taille') {
          const group = document.querySelector(`.vs-option-group[data-option-index="${index}"]`);
          if (!group) return;

          group.querySelectorAll('.vs-size-pill').forEach(pill => {
            const sizeVal = pill.dataset.optionValue;
            // Check if any variant with this size + current other selections is available
            const testOptions = [...selectedOptions];
            testOptions[index] = sizeVal;
            const matchingVariant = product.variants.find(v =>
              v.options.every((opt, i) => opt === testOptions[i])
            );

            if (matchingVariant && matchingVariant.available) {
              pill.classList.remove('vs-size-oos');
              pill.title = '';
            } else {
              pill.classList.add('vs-size-oos');
              pill.title = matchingVariant ? 'Out of stock' : 'Unavailable';
            }
          });
        }
      });
    }

    // Helper: update entire UI after a variant is found
    function updateVariantUI(variant) {
      if (!variant) return;

      // Update hidden select
      const selectEl = $('select[name="id"]');
      if (selectEl) selectEl.value = variant.id;

      // Update dynamic checkout hidden input
      const dynamicInput = $('#dynamic-checkout-variant');
      if (dynamicInput) dynamicInput.value = variant.id;

      // Update price display
      const priceNow = $('#pdp-price-now');
      if (priceNow) priceNow.textContent = '$' + (variant.price / 100).toFixed(2);

      const priceWas = $('#pdp-price-was');
      const priceSave = $('#pdp-price-save');
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const savings = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
        if (priceWas) {
          priceWas.textContent = '$' + (variant.compare_at_price / 100).toFixed(2);
          priceWas.style.display = '';
        }
        if (priceSave) {
          priceSave.textContent = '-' + savings + '%';
          priceSave.style.display = '';
        }
      } else {
        if (priceWas) priceWas.style.display = 'none';
        if (priceSave) priceSave.style.display = 'none';
      }

      // Update add to cart button
      const addBtn = $('#add-to-cart-btn');
      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.classList.remove('vs-sold-out');
          addBtn.textContent = addBtn.dataset.ctaText || 'ADD TO CART';
        } else {
          addBtn.disabled = true;
          addBtn.classList.add('vs-sold-out');
          addBtn.textContent = 'SOLD OUT';
        }
      }

      // Update variant image — switch main image + highlight matching thumb
      if (variant.featured_image) {
        const mainImg = $('#main-product-image');
        if (mainImg) {
          mainImg.src = variant.featured_image.src;
        }
        // Try to highlight matching thumbnail
        $$('.pdp-thumb').forEach(t => {
          t.classList.remove('active');
          if (t.dataset.imageUrl) {
            // Match by comparing the filename portion
            const thumbFile = t.dataset.imageUrl.split('?')[0].split('/').pop();
            const varFile = variant.featured_image.src.split('?')[0].split('/').pop();
            if (thumbFile === varFile) {
              t.classList.add('active');
            }
          }
        });
      }

      // Update URL without reload
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      // Update size availability based on new selection
      updateSizeAvailability();
    }

    // --- COLOR SWATCH (image thumbnail) clicks ---
    $$('.vs-swatch-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const group = btn.closest('.vs-color-swatches');
        if (group) {
          group.querySelectorAll('.vs-swatch-btn').forEach(b => b.classList.remove('active'));
        }
        btn.classList.add('active');

        updateSelectedLabel(btn.dataset.optionIndex, btn.dataset.optionValue);

        const selectedOptions = getSelectedOptions();
        const variant = findVariant(selectedOptions);
        if (variant) updateVariantUI(variant);
      });
    });

    // --- COLOR DOT clicks ---
    $$('.vs-dot').forEach(dot => {
      dot.addEventListener('click', () => {
        const group = dot.closest('.vs-color-dots');
        if (group) {
          group.querySelectorAll('.vs-dot').forEach(d => d.classList.remove('active'));
        }
        dot.classList.add('active');

        updateSelectedLabel(dot.dataset.optionIndex, dot.dataset.optionValue);

        const selectedOptions = getSelectedOptions();
        const variant = findVariant(selectedOptions);
        if (variant) updateVariantUI(variant);
      });
    });

    // --- SIZE PILL clicks ---
    $$('.vs-size-pill').forEach(pill => {
      pill.addEventListener('click', () => {
        const group = pill.closest('.vs-size-pills');
        if (group) {
          group.querySelectorAll('.vs-size-pill').forEach(p => p.classList.remove('active'));
        }
        pill.classList.add('active');

        updateSelectedLabel(pill.dataset.optionIndex, pill.dataset.optionValue);

        const selectedOptions = getSelectedOptions();
        const variant = findVariant(selectedOptions);
        if (variant) updateVariantUI(variant);
      });
    });

    // Initial size availability check on page load
    updateSizeAvailability();

    // --- QUANTITY BUTTONS ---
    $$('.pdp-quantity .quantity-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const input = btn.parentElement.querySelector('.quantity-input');
        let val = parseInt(input.value) || 1;
        
        if (btn.classList.contains('plus')) {
          val = Math.min(val + 1, 99);
        } else if (btn.classList.contains('minus')) {
          val = Math.max(val - 1, 1);
        }
        
        input.value = val;
      });
    });

    // --- TABS ---
    $$('.pdp-tab-btn').forEach(tab => {
      tab.addEventListener('click', () => {
        const tabId = tab.dataset.tab;
        
        // Remove active from all tabs and panels
        $$('.pdp-tab-btn').forEach(t => t.classList.remove('active'));
        $$('.pdp-tab-panel').forEach(p => p.classList.remove('active'));
        
        // Add active to clicked tab and matching panel
        tab.classList.add('active');
        const panel = document.getElementById(tabId);
        if (panel) panel.classList.add('active');
      });
    });

    // --- ADD TO CART (supports both .vs-add-to-cart and .pdp-add-to-cart) ---
    const productForm = $('form.product-form');
    if (productForm) {
      productForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = productForm.querySelector('.vs-add-to-cart') || productForm.querySelector('.pdp-add-to-cart');
        if (!btn || btn.disabled) return;

        const originalHTML = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="spin-icon"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg> ADDING...';

        try {
          const formData = new FormData(productForm);
          const res = await fetch('/cart/add.js', { method: 'POST', body: formData });

          if (res.ok) {
            btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> ADDED!';
            btn.style.background = '#2e7d32';
            
            await updateCartDrawer();
            
            setTimeout(() => {
              cartDrawer?.classList.add('active');
              cartOverlay?.classList.add('active');
              document.body.style.overflow = 'hidden';
            }, 600);

            setTimeout(() => {
              btn.innerHTML = originalHTML;
              btn.style.background = '';
              btn.disabled = false;
            }, 2000);

            saveRecentlyViewed(product);
          } else {
            const error = await res.json();
            btn.innerHTML = error.description || 'Error - Try Again';
            btn.style.background = '#c62828';
            setTimeout(() => {
              btn.innerHTML = originalHTML;
              btn.style.background = '';
              btn.disabled = false;
            }, 2500);
          }
        } catch (err) {
          btn.innerHTML = 'Error - Try Again';
          btn.style.background = '#c62828';
          setTimeout(() => {
            btn.innerHTML = originalHTML;
            btn.style.background = '';
            btn.disabled = false;
          }, 2500);
        }
      });
    }

    // Save current product to recently viewed
    saveRecentlyViewed(product);
  }

  // ============================================================
  // RECENTLY VIEWED PRODUCTS
  // ============================================================
  function saveRecentlyViewed(product) {
    if (!product || !product.handle) return;

    let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
    
    // Remove if already exists
    recentlyViewed = recentlyViewed.filter(p => p.handle !== product.handle);
    
    // Add to beginning
    recentlyViewed.unshift({
      handle: product.handle,
      title: product.title,
      url: '/products/' + product.handle,
      price: product.price,
      compare_at_price: product.compare_at_price,
      featured_image: product.featured_image ? (typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src) : '',
      images: product.images ? product.images.slice(0, 2).map(img => typeof img === 'string' ? img : img.src) : [],
      available: product.available
    });
    
    // Keep only last 12
    recentlyViewed = recentlyViewed.slice(0, 12);
    
    localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
  }

  function renderRecentlyViewed() {
    const container = $('.recently-viewed-products');
    if (!container) return;

    const grid = container.querySelector('.product-grid');
    if (!grid) return;

    let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
    
    // Don't show current product
    const currentHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
    recentlyViewed = recentlyViewed.filter(p => p.handle !== currentHandle);
    
    if (recentlyViewed.length === 0) {
      container.style.display = 'none';
      return;
    }

    container.style.display = '';
    
    grid.innerHTML = recentlyViewed.slice(0, 4).map(p => {
      const imgSrc = p.featured_image || '';
      const price = typeof p.price === 'number' ? '$' + (p.price / 100).toFixed(2) : p.price;
      let compareHtml = '';
      if (p.compare_at_price && p.compare_at_price > p.price) {
        const comparePrice = typeof p.compare_at_price === 'number' ? '$' + (p.compare_at_price / 100).toFixed(2) : p.compare_at_price;
        const savings = Math.round((p.compare_at_price - p.price) / p.compare_at_price * 100);
        compareHtml = `<span class="price-original">${comparePrice}</span><span class="price-discount">-${savings}%</span>`;
      }

      const secondImg = p.images && p.images[1] ? `<img src="${p.images[1]}" alt="${p.title}" class="product-image-secondary" loading="lazy">` : '';

      return `
        <div class="product-card">
          <a href="${p.url}" class="product-card-link">
            <div class="product-image">
              <img src="${imgSrc}" alt="${p.title}" loading="lazy">
              ${secondImg}
              ${!p.available ? '<div class="product-badges"><span class="product-badge badge-sold-out">SOLD OUT</span></div>' : ''}
            </div>
            <div class="product-info">
              <h3 class="product-name">${p.title}</h3>
              <div class="product-price">
                <span class="price-current">${price}</span>
                ${compareHtml}
              </div>
            </div>
          </a>
        </div>
      `;
    }).join('');
  }

  // Render recently viewed on product pages
  renderRecentlyViewed();

  // ============================================================
  // SIZE GUIDE MODAL (improved)
  // ============================================================
  const sizeGuideLinks = $$('[data-size-guide], .pdp-size-guide-link');
  const sizeGuideOverlay = $('.size-guide-overlay');
  const sizeGuideModal = $('.size-guide-modal');
  const sizeGuideClose = $('.size-guide-close');

  sizeGuideLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      sizeGuideOverlay?.classList.add('active');
      sizeGuideModal?.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  [sizeGuideClose, sizeGuideOverlay].forEach(el => {
    el?.addEventListener('click', () => {
      sizeGuideOverlay?.classList.remove('active');
      sizeGuideModal?.classList.remove('active');
      document.body.style.overflow = '';
    });
  });

  // Close modals on ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      // Size guide
      sizeGuideOverlay?.classList.remove('active');
      sizeGuideModal?.classList.remove('active');
      // Cart drawer
      cartDrawer?.classList.remove('active');
      cartOverlay?.classList.remove('active');
      // Mobile nav
      mobileNav?.classList.remove('active');
      mobileOverlay?.classList.remove('active');
      document.body.style.overflow = '';
    }
  });

  // ============================================================
  // WISHLIST
  // ============================================================
  let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

  // Migration: remove old numeric IDs
  (function migrateWishlist() {
    const hasNumericIds = wishlist.some(item => /^\d+$/.test(item));
    if (hasNumericIds) {
      wishlist = wishlist.filter(item => !/^\d+$/.test(item));
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
    }
  })();

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist]');
    if (!btn) return;
    
    e.preventDefault();
    const handle = btn.dataset.productHandle;
    if (!handle) return;
    
    const svg = btn.querySelector('svg');
    
    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(x => x !== handle);
      btn.classList.remove('active');
      if (svg) svg.setAttribute('fill', 'none');
      if (!svg && btn.textContent.trim() === '♥') btn.textContent = '♡';
    } else {
      wishlist.push(handle);
      btn.classList.add('active');
      if (svg) svg.setAttribute('fill', '#e53935');
      if (!svg && btn.textContent.trim() === '♡') btn.textContent = '♥';
    }
    
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
    
    $$('.wishlist-count').forEach(el => {
      el.textContent = wishlist.length;
      el.style.display = wishlist.length > 0 ? 'flex' : 'none';
    });
  });

  // Update wishlist UI on load
  $$('[data-wishlist]').forEach(btn => {
    if (wishlist.includes(btn.dataset.productHandle)) {
      btn.classList.add('active');
      const svg = btn.querySelector('svg');
      if (svg) svg.setAttribute('fill', '#e53935');
      if (!svg && btn.textContent.trim() === '♡') btn.textContent = '♥';
    }
  });
  
  $$('.wishlist-count').forEach(el => {
    el.textContent = wishlist.length;
    el.style.display = wishlist.length > 0 ? 'flex' : 'none';
  });

  // ============================================================
  // COLLECTION PAGE
  // ============================================================
  const sortSelected = $('.sort-selected');
  const sortOptions = $('.sort-options');

  sortSelected?.addEventListener('click', () => {
    sortOptions?.classList.toggle('active');
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.sort-dropdown')) {
      sortOptions?.classList.remove('active');
    }
    // Close search suggestions
    if (!e.target.closest('.search-container')) {
      searchSuggestions?.classList.remove('active');
    }
  });

  $$('.filter-group-header').forEach(header => {
    header.addEventListener('click', () => {
      const group = header.parentElement;
      group.classList.toggle('collapsed');
      const icon = header.querySelector('span:last-child');
      if (icon) icon.textContent = group.classList.contains('collapsed') ? '+' : '−';
    });
  });

  // ============================================================
  // HERO SLIDER
  // ============================================================
  const heroSlider = $('.hero-slider');
  if (heroSlider) {
    const slides = $$('.hero-slide');
    const dots = $$('.hero-dot');
    let current = 0;

    function showSlide(n) {
      slides.forEach((s, i) => s.style.display = i === n ? 'flex' : 'none');
      dots.forEach((d, i) => d.classList.toggle('active', i === n));
      current = n;
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => showSlide(i));
    });

    if (slides.length > 1) {
      showSlide(0);
      setInterval(() => {
        showSlide((current + 1) % slides.length);
      }, 5000);
    }
  }

  // ============================================================
  // COUNTDOWN TIMER
  // ============================================================
  const countdown = $('#flash-countdown');
  if (countdown) {
    setInterval(() => {
      const now = new Date();
      const end = new Date(now);
      end.setHours(24, 0, 0, 0);
      const diff = end - now;
      
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      
      const items = countdown.querySelectorAll('.countdown-item');
      if (items[0]) items[0].textContent = String(h).padStart(2, '0');
      if (items[1]) items[1].textContent = String(m).padStart(2, '0');
      if (items[2]) items[2].textContent = String(s).padStart(2, '0');
    }, 1000);
  }

  // Init cart count
  updateCartDrawer();

})();
